import { useState } from 'react';
import api from '../api';
import secureStorage from '../../utils/SecureStorage';

const BuscaPontoMesAnterior = () => {
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_35;

  const loadregistros = async (id_rede) => {
    setLoading(true);
    try {
      const response = await api.get(`${apiUrl}${id_rede}`);
      if (response.data) { // Corrigido o erro aqui
        // Atualiza o estado com os novos dados
        secureStorage.setItem("dataponto", JSON.stringify(response.data));
        setSearchResults(response.data); // Define corretamente os resultados
        
      } else {
        setError("Erro ao buscar cadastros. Veja o console para mais detalhes.");
        setSearchResults([]); // Limpa os resultados
      }
    } catch (error) {
      setError("Erro ao buscar cadastros. Veja o console para mais detalhes.");
      setSearchResults([]); // Limpa os resultados anteriores
    } finally {
      setLoading(false);
    }
  };

  return { loading, searchResults, error, loadregistros };
};

export default BuscaPontoMesAnterior;
